const postponeStatuses4XX = new Set([
  401, // Unauthorized
  407, // Proxy Authentication Required
  408, // Request Timeout
  410, // Gone
  418, // I'm a teapot
  421, // Misdirected Request
  423, // Locked (WebDAV)
  424, // Failed Dependency (WebDAV)
  429, // Too Many Requests
  451, // Unavailable For Legal Reasons
]);

export function shouldPostponeAction(action, error) {
  if (error?.response?.status === 401) {
    if (error?.response?.data?.errors?.[0]?.code === 'QCS-0401-19') {
      return false;
    }
  }

  if (
    !error.response ||
    postponeStatuses4XX.has(error.response.status) || // 4??
    (error.response.status && error.response.status >= 500 && error.response.status < 600) // 5xx
  ) {
    return !action.meta || action.meta.attemptsLeft === undefined || action.meta.attemptsLeft;
  }

  return false;
}
